import PaymentHistoryDetailsScreen from 'features/believe/PaymentHistory/PaymentHistoryDetails/PaymentHistoryDetailsScreen';
import React from 'react';

export default function PaymentHistoryDetailsPage() {
  return <PaymentHistoryDetailsScreen />;
}
